import { getApps, initializeApp } from 'firebase/app';
import { firebaseConfig } from '../firebaseConfig';

// Query param carrying the short-lived, HMAC-signed "mobile return" token
// minted server-side (see signMobileReturnToken in functions/index.js).
//
// NOTE: this used to be a real Firebase Auth custom token consumed via
// signInWithCustomToken(). That relied on admin.auth().createCustomToken(),
// which requires the Cloud Functions runtime service account to hold the
// "Service Account Token Creator" IAM role on itself — a grant this
// project's service account does not have, so it failed on every call. The
// pages that used it (PlansPage/OnboardingPage/ReturnPage/
// SubscriptionSuccessPage) now don't try to establish a real Firebase Auth
// session in this external/no-login browser context at all; instead they
// pass this token directly as `returnToken` in the payload of whichever
// Cloud Function they call, and the backend verifies it there
// (resolveUidOrReturnToken).
const RETURN_TOKEN_PARAM = 'return_token';

export const ensureFirebaseApp = () => {
  if (!getApps().length) {
    initializeApp(firebaseConfig);
  }
};

export const getReturnToken = (searchParams) => (searchParams.get(RETURN_TOKEN_PARAM) || '').trim();

export const getPathWithoutReturnToken = (searchParams) => {
  const params = new URLSearchParams(searchParams);
  params.delete(RETURN_TOKEN_PARAM);
  const query = params.toString();
  const hash = window.location.hash || '';
  return `${window.location.pathname}${query ? `?${query}` : ''}${hash}`;
};
